/* KrakenTheMeta dashboard — Arena: games tracked by the Kraken Assistant desktop app, per-deck
 * records, publishing an Arena deck to the site, and the "public on my profile" switch.
 */
(function () {
  "use strict";

  var KD = window.KD, S = KD.state, D = KD.data, esc = KD.esc;
  var LBL = { win: "Win", loss: "Loss", draw: "Draw", demo: "Demo" };

  // One match as a row linking to its recap page (stats, play-by-play, replay). Used on Home too.
  KD.matchRow = function (m, multiAccount) {
    var when = KD.toDate(m.endedAt);
    var res = String(m.result || "");
    var opp = (m.oppRevealed || []).slice(0, 3).join(", ") || (m.oppCardsSeen ? m.oppCardsSeen + " cards seen" : "");
    var life = (m.youLifeEnd != null || m.oppLifeEnd != null) ? " · " + (m.youLifeEnd != null ? m.youLifeEnd : "?") + "–" + (m.oppLifeEnd != null ? m.oppLifeEnd : "?") : "";
    var sub = [opp ? "vs " + opp : "", m.coachUsed ? "coached" : "", multiAccount && m.arenaPlayer ? m.arenaPlayer : ""].filter(Boolean).join(" · ");
    return '<a class="arow" href="' + KD.SITE + "/match-recap?u=" + encodeURIComponent(S.user.id) + "&m=" + encodeURIComponent(m._id) + '">' +
      '<span class="result ' + (LBL[res] ? esc(res) : "") + '">' + (LBL[res] || "–") + "</span>" +
      '<div class="arow__main"><div class="arow__line">' + (m.deckName ? esc(m.deckName) + " · " : "") + (m.turns || 0) + " " + KD.plural(m.turns || 0, "turn") + life + "</div>" +
        '<div class="arow__sub">' + esc(sub || (m.hasTimeline ? "Recap and replay" : "Recap")) + "</div></div>" +
      '<span class="arow__when">' + (when ? esc(KD.ago(when)) : "") + "</span></a>";
  };

  KD.routes.arena = function (view) {
    var st = { account: "all", deck: "all" };
    var data = null, root;
    view.innerHTML = '<div data-arena>' +
      '<div class="vhead"><div class="vhead__text"><p class="depth-tag">The arena</p><h2>Arena</h2><p>Every MTG Arena game the Kraken Assistant tracks, with coached recaps and replays.</p></div>' +
        '<div class="vhead__actions">' +
          (S.isPro ? '<span class="badge badge--glow">' + KD.icon("sparkle") + "Pro · coached every turn</span>"
            : '<button class="btn btn--gold" type="button" data-checkout="pro">Go Pro</button>') +
          '<a class="btn btn--ghost" href="' + KD.SITE + '/arena-assistant">' + KD.icon("download") + "<span>Get the app</span></a>" +
        "</div></div>" +
      '<div class="tiles" data-tiles>' + ["Matches", "Wins", "Losses", "Win rate"].map(function (l) { return '<div class="tile"><b>…</b><span>' + l + "</span></div>"; }).join("") + "</div>" +
      "<div data-body></div>" +
    "</div>";
    root = KD.$("[data-arena]", view);

    D.loadArena().then(function (d) {
      if (!document.body.contains(root)) return;
      data = d;
      paint();
    }).catch(function (e) {
      console.error("arena", e);
      if (document.body.contains(root)) KD.$("[data-body]", root).innerHTML = '<div class="empty">' + KD.icon("alert") + "<h3>Couldn't load your Arena history</h3><p>Check your connection and refresh the page.</p></div>";
    });

    root.addEventListener("click", async function (e) {
      var t = e.target, el;
      if ((el = t.closest("[data-acct]"))) { st.account = el.dataset.acct; paint(); return; }
      if (t.closest("[data-clear-deck]")) { st.deck = "all"; paint(); return; }
      if ((el = t.closest("[data-adeck-matches]"))) {
        st.deck = el.dataset.adeckMatches;
        paint();
        var list = KD.$("[data-matches]", root);
        if (list) list.scrollIntoView({ behavior: KD.reduce ? "auto" : "smooth", block: "start" });
        return;
      }
      if ((el = t.closest("[data-adeck-cards]"))) {
        var box = KD.$('[data-cards-for="' + el.dataset.adeckCards + '"]', root);
        if (!box) return;
        if (!box.hidden) { box.hidden = true; el.setAttribute("aria-expanded", "false"); return; }
        var dk = data.decks.find(function (x) { return x._id === el.dataset.adeckCards; });
        box.innerHTML = (dk.cards || []).map(function (c) { return "<span>" + (c.count || 1) + "× " + esc(c.name) + "</span>"; }).join("") || '<span class="muted">No cards recorded.</span>';
        box.hidden = false;
        el.setAttribute("aria-expanded", "true");
        return;
      }
      if ((el = t.closest("[data-adeck-pub]"))) { publish(el); }
    });
    root.addEventListener("change", async function (e) {
      if (!e.target.matches("[data-public]")) return;
      var on = e.target.checked;
      try { await D.setArenaPublic(on); KD.toast(on ? "Your Arena stats are on your public profile." : "Your Arena stats are hidden from your public profile.", "ok"); }
      catch (err) { e.target.checked = !on; KD.toast("Couldn't update that setting.", "err"); }
    });

    function paint() {
      var all = data.matches, accounts = Array.from(new Set(all.map(function (m) { return m.arenaPlayer; }).filter(Boolean)));
      var ms = st.account === "all" ? all : all.filter(function (m) { return m.arenaPlayer === st.account; });
      if (st.deck !== "all") ms = ms.filter(function (m) { return m.deckId === st.deck; });
      var wins = ms.filter(function (m) { return m.result === "win"; }).length;
      var losses = ms.filter(function (m) { return m.result === "loss"; }).length;
      var wr = wins + losses ? Math.round(wins / (wins + losses) * 100) : 0;
      KD.$("[data-tiles]", root).innerHTML =
        '<div class="tile"><b>' + KD.fmt(ms.length) + "</b><span>Matches</span></div>" +
        '<div class="tile is-win"><b>' + KD.fmt(wins) + "</b><span>Wins</span></div>" +
        '<div class="tile is-loss"><b>' + KD.fmt(losses) + "</b><span>Losses</span></div>" +
        '<div class="tile"><b>' + (wins + losses ? wr + "%" : "–") + "</b><span>Win rate</span></div>";

      var body = KD.$("[data-body]", root);
      if (!all.length && !data.decks.length) {
        body.innerHTML = '<div class="empty panel mt-24">' + KD.icon("swords") + "<h3>No games yet</h3>" +
          "<p>Install the free Kraken Assistant for MTG Arena and sign in with this account. Every game you play lands here with a recap, and Pro coaches you through each turn.</p>" +
          '<a class="btn btn--lure" href="' + KD.SITE + '/arena-assistant">' + KD.icon("download") + "Get the Assistant</a>" +
          '<p class="hint">Windows now · macOS coming soon</p></div>';
        return;
      }
      var deckName = st.deck !== "all" ? ((data.decks.find(function (x) { return x._id === st.deck; }) || {}).name || "Selected deck") : "";
      var chips = accounts.length > 1 || st.deck !== "all"
        ? '<div class="chips mb-12">' + (accounts.length > 1 ? ["all"].concat(accounts).map(function (a) {
            return '<button type="button" class="chip' + (st.account === a ? " is-on" : "") + '" data-acct="' + esc(a) + '">' + (a === "all" ? "All accounts" : esc(a)) + "</button>";
          }).join("") : "") +
          (st.deck !== "all" ? '<button type="button" class="chip is-on" data-clear-deck>' + esc(deckName) + KD.icon("x") + "</button>" : "") + "</div>"
        : "";

      body.innerHTML =
        (data.decks.length ? '<div class="shead"><h3>Your Arena decks</h3>' +
          '<label class="check" style="font-size:13.5px"><input type="checkbox" data-public' + (data.isPublic ? " checked" : "") + "><span>Show on my public profile</span></label></div>" +
          '<div class="panel">' + data.decks.map(deckRow).join("") + "</div>" : "") +
        '<div class="shead" data-matches><h3>Matches</h3>' +
          '<a href="' + KD.SITE + "/profile.php?userId=" + encodeURIComponent(S.user.id) + '" target="_blank" rel="noopener">Your public profile</a></div>' +
        chips +
        (ms.length ? '<div class="panel arows">' + ms.map(function (m) { return KD.matchRow(m, accounts.length > 1); }).join("") + "</div>"
          : '<div class="empty panel">' + KD.icon("swords") + "<p>No matches for that filter yet.</p></div>");
    }

    function deckRow(d) {
      var last = KD.toDate(d.lastPlayedAt);
      var total = (d.cards || []).reduce(function (s, c) { return s + (c.count || 1); }, 0);
      var games = d.games || 0;
      var pub = d.publishedDeckId
        ? '<a class="btn btn--ghost btn--sm" href="' + KD.SITE + "/deck-view?deckId=" + encodeURIComponent(d.publishedDeckId) + '" target="_blank" rel="noopener">' + KD.icon("eye") + "View</a>" +
          '<button class="btn btn--ghost btn--sm" type="button" data-adeck-pub="' + esc(d._id) + '">' + KD.icon("refresh") + "Update</button>"
        : '<button class="btn btn--lure btn--sm" type="button" data-adeck-pub="' + esc(d._id) + '">' + KD.icon("globe") + "Publish</button>";
      return '<div class="adeck">' +
        '<div><div class="adeck__name">' + esc(d.name || "Arena deck") + (d.publishedDeckId ? '<span class="badge badge--glow">Public</span>' : "") + "</div>" +
          '<div class="adeck__meta">' + (d.format ? esc(D.formatLabel(d.format)) + " · " : "") +
            '<span class="w">' + (d.wins || 0) + '</span>–<span class="l">' + (d.losses || 0) + "</span> · " + games + " " + KD.plural(games, "game") +
            " · " + total + " cards" + (last ? " · " + esc(KD.ago(last)) : "") + "</div></div>" +
        '<div class="adeck__acts">' +
          '<button class="btn btn--ghost btn--sm" type="button" data-adeck-matches="' + esc(d._id) + '">Matches</button>' +
          '<button class="btn btn--ghost btn--sm" type="button" data-adeck-cards="' + esc(d._id) + '" aria-expanded="false">Cards</button>' + pub +
        "</div>" +
        '<div class="adeck__cards" data-cards-for="' + esc(d._id) + '" hidden></div></div>';
    }

    var publishing = false;
    async function publish(btn) {
      if (publishing) return;
      var d = data.decks.find(function (x) { return x._id === btn.dataset.adeckPub; });
      if (!d) return;
      var update = !!d.publishedDeckId;
      if (!update) {
        var ok = await KD.confirm({ title: "Publish “" + (d.name || "Arena deck") + "”?", body: "<p>It gets a public page on KrakenTheMeta with its Arena record, and the record updates by itself after every game you play with it.</p>", confirm: "Publish" });
        if (!ok) return;
      }
      publishing = true;
      KD.busy(update ? "Updating the public page…" : "Publishing…");
      try {
        await D.publishArenaDeck(d);
        KD.idle();
        KD.toast(update ? "Public page updated." : "Published. Its record updates as you play.", "ok");
        if (document.body.contains(root)) paint();
      } catch (e) {
        console.error("publishArenaDeck", e);
        KD.idle();
        KD.toast("Publishing failed. Try again.", "err");
      } finally { publishing = false; }
    }
  };
})();
